import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { HttpService } from '../../services/http-service/http.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EntityFormGroup } from '../entities/EntityFormGroup';
import { Import } from '../entities/Import';
import { ImportEntity } from '../entities/ImportEntity';
import { ImportProfile } from '../entities/ImportProfile';
import { ImportProfileTemplate } from '../entities/ImportProfileTemplate';
import { Mapping } from '../entities/Mapping';
import { TranslationService } from './translation.service';

import { baseHOST } from '../../routes';

@Injectable()
export class ImportService {

  serverUrl: string = baseHOST;
  prefixImport: string = '/api/import/v1/';

  constructor(private http: HttpService, private httpClient: HttpClient, private translationService: TranslationService) { }

  // manual import

  createImportPreview(entityType: string, uploadedFile: File, importEntityPrimaryKeys, importEntityReadableNameKeys, fixedHeaderRowNumber, rowOffset) {
    const formData: FormData = new FormData();
    formData.append('entity_type', entityType);
	formData.append('file', uploadedFile);
	var i = 0;
	for (i = 0; i < importEntityPrimaryKeys.length; i++) {
		formData.append('import_entity_primary_keys[' + i + ']', importEntityPrimaryKeys[i]);
	}
	for (i = 0; i < importEntityReadableNameKeys.length; i++) {
		formData.append('import_entity_readable_name_keys[' + i + ']', importEntityReadableNameKeys[i]);
	}
	
	formData.append('fixed_header_row_number', fixedHeaderRowNumber);
	formData.append('row_offset', rowOffset);
	
    return this.http.post(this.serverUrl + this.prefixImport + 'imports/preview', formData);
  }

  getImportEntityFormData(entityId: string): Observable<EntityFormGroup[]> {
    return this.http.get<EntityFormGroup[]>(this.serverUrl + this.prefixImport + 'entities/' + entityId + '/form');
  }

  getImportEntity(entityId: string): Observable<ImportEntity> {
	  return this.http.get<ImportEntity>(this.serverUrl + this.prefixImport + 'entities/' + entityId);
  }

  createImportEntity(importEntity: ImportEntity) {
	const formData: FormData = new FormData();
    formData.append('import_profile', importEntity['import_profile']);
	if (importEntity['primary_key']) formData.append('primary_key', importEntity['primary_key']);
	if (importEntity['database_entity']) formData.append('database_entity', importEntity['database_entity']);

	return this.http.post(this.serverUrl + this.prefixImport + 'entities', formData);
  }

  updateImportEntity(importEntity: ImportEntity): Observable<ImportEntity> {
	var body = {};
	if (!importEntity['database_entity']) body['database_entity'] = null;
	else body['database_entity'] = importEntity['database_entity'];
    return this.http.patch<ImportEntity>(this.serverUrl + this.prefixImport + 'entities/' + importEntity.id, body);
  }

  acceptImportEntity(importEntity: ImportEntity): Observable<ImportEntity> {
	  return this.http.patch<ImportEntity>(this.serverUrl + this.prefixImport + 'entities/' + importEntity.id + '/accept', null);
  }

  rejectImportEntity(importEntity: ImportEntity): Observable<ImportEntity> {
	return this.http.patch<ImportEntity>(this.serverUrl + this.prefixImport + 'entities/' + importEntity.id + '/reject', null);
  }

  deleteImportEntity(importEntity: ImportEntity) {
    return this.http.delete<ImportEntity>(this.serverUrl + this.prefixImport + 'entities/' + importEntity.id);
  }

  deleteAllImportEntitiesFromImportProfile(importProfile: ImportProfile) {
	  return this.http.delete<ImportProfile>(this.serverUrl + this.prefixImport + 'profiles/' + importProfile.id + '/entities');
  }

  createImport(importId: string, mappings: Array<Mapping>, preventUpdate: boolean = false) {
    const formData: FormData = new FormData();
    formData.append('import', importId);
    console.log(importId);
	formData.append('mappings', JSON.stringify(mappings));
	mappings.forEach(function (mapping) {
		if (mapping['candidates']) delete mapping['candidates'];
	});
    console.log(JSON.stringify(mappings));
	formData.append('prevent_update', JSON.stringify(preventUpdate));
	console.log(JSON.stringify(preventUpdate));
    return this.http.post(this.serverUrl + this.prefixImport + 'imports', formData);
  }

  createEntity(entityType: string, formData) {
	  entityType = this.translationService.convertEntityType(entityType);
    return this.http.post(this.serverUrl + this.prefixImport + 'valuemappings/' + entityType + '/createentities', formData);
  }

  loadAllCandidates(entityType: string, fieldName: string, hostEntityType: string = null) {
	entityType = this.translationService.convertEntityType(entityType);
	var hostEntity = '';
	if (hostEntityType !== null) hostEntity = '&host_entity_type=' + this.translationService.convertEntityType(hostEntityType);
    return this.http.get(this.serverUrl + this.prefixImport + 'entities/candidates?entity_type=' + entityType + '&field_name=' + fieldName + hostEntity);
  }

  loadSimilarities(importEntity: ImportEntity) {
	  return this.http.get(this.serverUrl + this.prefixImport + 'entities/' + importEntity.id + '/similarities');
  }

  getCorrectForm(entityType: string, method: string, objectId: string) {
	entityType = this.translationService.convertEntityType(entityType);
  var url = this.serverUrl + this.prefixImport + 'entities/form?entity_type=' + entityType + '&method=' + method;
  if (objectId) url += '&objectId=' + objectId;
    return this.http.get(url);
  }

  getMappings(importId: string): Observable<Mapping[]> {
    return this.http.get<Mapping[]>(this.serverUrl + this.prefixImport + 'mappings?import=' + importId);
  }

  getCustomMappingFunctions(): Observable<string[]> {
	  return this.http.get<string[]>(this.serverUrl + this.prefixImport + 'mappings/customfunctions');
  }

  // importprofile templates

  getProfileTemplates(params: HttpParams): Observable<any>  {
    return this.httpClient.get<HttpResponse<any>>(this.serverUrl + this.prefixImport + 'profiletemplates', { params: params, observe: 'response'});
  }

  getProfileTemplate(profileTemplateId: string): Observable<ImportProfileTemplate> {
    return this.http.get<ImportProfileTemplate>(this.serverUrl + this.prefixImport + 'profiletemplates/' + profileTemplateId);
  }

  getProfileTemplateProfileCandidates(profileTemplateId: string) {
	return this.http.get(this.serverUrl + this.prefixImport + 'profiletemplates/' + profileTemplateId + '/profilecandidates');
}

  createProfileTemplate(profileTemplate: ImportProfileTemplate) {
    return this.http.post(this.serverUrl + this.prefixImport + 'profiletemplates', profileTemplate);
  }

  updateProfileTemplate(profileTemplate: ImportProfileTemplate): Observable<ImportProfileTemplate> {
    return this.http.patch<ImportProfileTemplate>(this.serverUrl + this.prefixImport + 'profiletemplates/' + profileTemplate.id, profileTemplate);
  }

  deleteProfileTemplate(profileTemplateId: string) {
    return this.http.delete<ImportProfileTemplate>(this.serverUrl + this.prefixImport + 'profiletemplates/' + profileTemplateId);
  }

  // importprofiles

  getProfiles(params: HttpParams): Observable<any>  {
    return this.httpClient.get<HttpResponse<any>>(this.serverUrl + this.prefixImport + 'profiles', { params: params, observe: 'response'});
  }

  getProfileCandidates(profileId: string) {
	  return this.http.get(this.serverUrl + this.prefixImport + 'profiles/' + profileId + '/candidates');
  }

  getProfileFileInfos(profileId: string) {
	  return this.http.get(this.serverUrl + this.prefixImport + 'profiles/' + profileId + '/fileinfos');
  }

  getProfile(profileId: string): Observable<ImportProfile> {
    return this.http.get<ImportProfile>(this.serverUrl + this.prefixImport + 'profiles/' + profileId);
  }

  getImportEntities(params: HttpParams): Observable<any> {
	  return this.httpClient.get<HttpResponse<any>>(this.serverUrl + this.prefixImport + 'entities', { params: params, observe: 'response'});
  }

  getProfileReferences(profileId: string): Observable<string[]> {
    return this.http.get<string[]>(this.serverUrl + this.prefixImport + 'profiles/' + profileId + '/references');
  }

  createProfile(profile: ImportProfile) {
    profile.query_params.forEach(queryParam => {
      if (queryParam.type === 'array') {
        var values = [];
        queryParam.array_value.forEach(arrayValue => {
          values.push(arrayValue.value);
        });
        queryParam.value = values.join();
      }
    })
    return this.http.post(this.serverUrl + this.prefixImport + 'profiles', profile);
  }

  updateProfile(profile: ImportProfile): Observable<ImportProfile> {
    return this.http.patch<ImportProfile>(this.serverUrl + this.prefixImport + 'profiles/' + profile.id, profile);
  }

  testApiForProfile(profile: ImportProfile) {
	  return this.http.get<string>(this.serverUrl + this.prefixImport + 'profiles/' + profile.id + '/test');
  }

  manualProfileImport(profile: ImportProfile) {
    return this.http.post(this.serverUrl + this.prefixImport + 'profiles/' + profile.id + '/import', {});
  }

  deleteProfile(profileId: string) {
    return this.http.delete<ImportProfile>(this.serverUrl + this.prefixImport + 'profiles/' + profileId);
  }

  toggleProfileState(profileId: string) {
    return this.http.patch<ImportProfile>(this.serverUrl + this.prefixImport + 'profiles/' + profileId + '/toggleactive', null);
  }

  // import history

  getImports(params: HttpParams): Observable<any> {
    return this.httpClient.get<HttpResponse<any>>(this.serverUrl + this.prefixImport + 'imports', { params: params, observe: 'response'});
  }

  getImport(importId: string): Observable<Import> {
    return this.http.get<Import>(this.serverUrl + this.prefixImport + 'imports/' + importId);
  }

  // various helper functions

  getClassInfos(entityType = null, depth = null): Observable<string[]> {
    var queryString = '';
	if (entityType) queryString = '?entity_type=' + entityType;
	if (depth) {
		if (queryString != '') {
			queryString += '&depth=' + depth;
		} else {
			queryString = '?depth=' + depth;
		}
	}

    return this.http.get<string[]>(this.serverUrl + this.prefixImport + 'imports/entitytypes' + queryString);
  }

  // get incomplete profiles
  getIncompleteProfiles(): Observable<ImportProfile[]> {
	  return this.http.get<ImportProfile[]>(this.serverUrl + this.prefixImport + 'profiles/incomplete');
  }

  getEditedProfiles(): Observable<ImportProfile[]> {
	  return this.http.get<ImportProfile[]>(this.serverUrl + this.prefixImport + 'profiles/edited');
  }

  getReviewableProfiles(): Observable<ImportProfile[]> {
	  return this.http.get<ImportProfile[]>(this.serverUrl + this.prefixImport + 'profiles/reviewable');
  }

  getDetailedImportEntity(importEntity: ImportEntity, associatedFieldName = null, hostEntityType = null) {
	  var queryParams = '';
	  if (associatedFieldName && associatedFieldName !== null) queryParams += '?associated_field_name=' + associatedFieldName;
	  if (hostEntityType && hostEntityType !== null) queryParams += '&host_entity_type=' + hostEntityType;
	  return this.http.get(this.serverUrl + this.prefixImport + 'entities/' + importEntity.id + '/details' + queryParams);
  }

  revertImport(importId: string) {
	  return this.http.delete<Import>(this.serverUrl + this.prefixImport + 'imports/' + importId + '/revert');
  }

  flushStorage(importProfile: ImportProfile) {
	return this.http.post(this.serverUrl + this.prefixImport + 'profiles/' + importProfile.id + '/flush', {});
  }

  uploadFileForProfile(importProfile: ImportProfile, uploadedFile: File) {
	const formData: FormData = new FormData();
	formData.append('file', uploadedFile);
	return this.http.post(this.serverUrl + this.prefixImport + 'profiles/' + importProfile.id + '/uploadfile', formData);
  }

  downloadFile(importProfile: ImportProfile, filename: string): Observable<any> {
	  return this.http.get(this.serverUrl + this.prefixImport + 'profiles/' + importProfile.id + '/downloadfile?filename=' + filename);
  }

  deleteFileForProfile(importProfile: ImportProfile, filename: string) {
	const formData: FormData = new FormData();
	formData.append('filename', filename);
	return this.http.post(this.serverUrl + this.prefixImport + 'profiles/' + importProfile.id + '/deletefile', formData);
  }

  updateHeadersForProfile(importProfile: ImportProfile, filename: string) {
	var body = {};
	body['filename'] = filename;
	return this.http.patch(this.serverUrl + this.prefixImport + 'profiles/' + importProfile.id + '/headers', body);
  }

  scanFile(uploadedFile: File, fixedHeaderRowNumber, ignoreKeys, keyIndex, rowOffset, sheetName) {
	const formData: FormData = new FormData();
	formData.append('file', uploadedFile);
	if (fixedHeaderRowNumber != null) formData.append('fixed_header_row_number', '' + fixedHeaderRowNumber);
	if (ignoreKeys != null) formData.append('ignore_keys', ignoreKeys);
	if (keyIndex != null) formData.append('key_index', keyIndex);
	if (rowOffset != null) formData.append('row_offset', '' + rowOffset);
  if (sheetName != null) formData.append('sheet_name', sheetName);
	return this.http.post(this.serverUrl + this.prefixImport + 'imports/scanfile', formData);
  }
}